import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IImBotRegistration } from '@nimbus-library/features/feature-permission/models/i-im-bot-registration.model';
import { IAcsDriverApiService } from '@nimbus-library/features/feature-permission/services/contracts/i-acs-driver-api.service';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';

@Injectable()
export class AcsDriverApiService extends IAcsDriverApiService {
  public constructor(private readonly baseHttpService: BaseHttpService) {
    super();
  }

  public getImBotRegistrationByO365Id(o365Id: string): Observable<IImBotRegistration> {
    return this.baseHttpService.get(`acs-driver/v1/users/${o365Id}/instant-messaging/registration`);
  }
}
